import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import {
  fetchUserChatMessages,
  fetchUserChats,
} from 'store/modules/chatbot_assistant_store/actions';
import { ChatbotAssistantState } from 'store/modules/chatbot_assistant_store/types';
import ChatbotMessage from 'components/atoms/chatbot_message';
import moment from 'moment';
import SquareLoader from 'components/atoms/square_loader';

interface ChatListTypes {
  value: number;
  label: string;
}

const ChatbotAssistantHistory = () => {
  const dispatch = useDispatch();

  const { chatbot_assistant, request } = useSelector<ApplicationState, ChatbotAssistantState>(
    (state) => state.session.chatbot_assistant,
  );

  const [chatList, setChatList] = useState<Array<ChatListTypes>>([]);
  const [selectedChat, setSelectedChat] = useState<ChatListTypes | null>(null);

  useEffect(() => {
    dispatch(fetchUserChats());
  }, []);

  useEffect(() => {
    setChatList(
      chatbot_assistant.user_chats
        .filter((chat) => {
          return chat.id !== chatbot_assistant.current_chat_id;
        })
        .map((chat) => {
          return { value: chat.id, label: chat.created_at };
        }),
    );
  }, [chatbot_assistant.user_chats]);

  useEffect(() => {
    if (!selectedChat) return;
    if (chatbot_assistant.user_chat_messages[selectedChat?.value || '0']) return;

    dispatch(fetchUserChatMessages({ assistant_user_chat_id: selectedChat.value }));
  }, [selectedChat]);

  return (
    <>
      {selectedChat && (
        <button
          className="btn-chatbot-history d-flex p-3 text-white  align-items-center"
          type="button"
          onClick={() => setSelectedChat(null)}
        >
          <span className="material-icons mr-3">navigate_before</span>
          <span>
            Conversa do dia {moment(selectedChat.label).format('DD/MM/YYYY')} às{' '}
            {moment(selectedChat.label).format('HH:mm')}
          </span>
        </button>
      )}
      {request.fetch_user_chats.loaded && !selectedChat && (
        <div className="chat-list overflow-auto">
          {chatList.map((chat) => (
            <button
              className="btn-chatbot-history d-flex p-3 text-white justify-content-between align-items-center"
              type="button"
              onClick={() => setSelectedChat(chat)}
              key={chat.value}
            >
              <span>
                {moment(chat.label).format('DD/MM/YYYY')} às {moment(chat.label).format('HH:mm')}
              </span>
              <span className="material-icons">navigate_next</span>
            </button>
          ))}
        </div>
      )}
      <div className="chatbot-body">
        {request.fetch_user_chats.loaded &&
          (chatbot_assistant.user_chats?.length === 0 ||
            (chatbot_assistant.user_chats[0]?.id === chatbot_assistant.current_chat_id &&
              chatbot_assistant.user_chats?.length === 1)) && (
            <div className="d-flex text-white align-items-center justify-content-center h-100">
              Você ainda não possui um histórico de chats.
            </div>
          )}

        <div className="chatbot-messages">
          {request.fetch_user_chats.loading && (
            <div className="d-flex text-white align-items-center justify-content-center h-100">
              <div className="position-relative">
                Carregando chats <SquareLoader customClass="chatbot-loading" />
              </div>
            </div>
          )}
          {request.fetch_user_chat_message.loading && (
            <div className="d-flex text-white align-items-center justify-content-center h-100">
              <div className="position-relative">
                Carregando mensagens <SquareLoader customClass="chatbot-loading" />
              </div>
            </div>
          )}
          {request.fetch_user_chat_message.loaded &&
            chatbot_assistant.user_chat_messages[selectedChat?.value || '0'] &&
            chatbot_assistant.user_chat_messages[selectedChat?.value || '0'].map((message) => (
              <ChatbotMessage message={message} source="history" />
            ))}
        </div>
      </div>
    </>
  );
};

export default ChatbotAssistantHistory;
